import { useEffect } from 'react';
import { getMemberAccessToken } from '../auth/supabase';
import { activeDeploymentsForPerson, operationalAssets } from './deploymentUsageModel';
import { prefetchOfflineInventory } from './offlineInventoryCache';

function actorName(member) {
  return String(member?.full_name || '').trim();
}

export default function OfflineInventoryWarmup({ member }) {
  useEffect(() => {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return undefined;
    const person = actorName(member);
    if (!person) return undefined;
    let cancelled = false;

    getMemberAccessToken()
      .then(token => {
        if (!token) return null;
        return fetch('/api/member-tracking-state', {
          cache: 'no-store',
          headers: { Authorization: `Bearer ${token}` },
        });
      })
      .then(response => response && response.ok ? response.json() : null)
      .then(state => {
        if (cancelled || !state) return;
        const deploymentIds = new Set(activeDeploymentsForPerson(state, person).map(item => item.id));
        const assetIds = operationalAssets(state)
          .filter(asset => asset.currentDeploymentId && deploymentIds.has(asset.currentDeploymentId))
          .map(asset => asset.id);
        if (assetIds.length) prefetchOfflineInventory(assetIds).catch(() => {});
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, [member]);

  return null;
}
